import { useState, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { StyledSearchContainer, StyledRoutingContainer } from './styled'
import { motion, AnimatePresence } from 'framer-motion'
import { ENV } from '~/constants/env'
import IconCurve from '~/assets/images/protocol-logo-curve.svg'
import IconSushiSwap from '~/assets/images/protocol-logo-sushi-swap.svg'
import IconUniswap from '~/assets/images/protocol-logo-uniswap.svg'
import IconBalancer from '~/assets/images/protocol-logo-balancer.svg'
import IconPancake from '~/assets/images/protocol-logo-pancake.svg'
import IconDsspsm from '~/assets/images/protocol-logo-dsspsm.svg'
import IconSynapse from '~/assets/images/protocol-logo-synapse.svg'
import IconTokenlon from '~/assets/images/protocol-logo-tokenlon.svg'

const DefaultLoading: React.FC = () => {
  const { t } = useTranslation()

  const [currentRoutingImg, setCurrentRoutingImg] = useState(0)
  // 后续有时间可以考虑通过 admin 平台配置，前端读取有哪些流动性
  const isProd = ENV.production
  const routingImages = useMemo(() => {
    const iconArray = isProd
      ? [
          IconUniswap,
          IconSushiSwap,
          IconDsspsm,
          IconPancake,
          IconSynapse,
          IconCurve,
          IconTokenlon,
        ]
      : [
          IconCurve,
          IconUniswap,
          IconSushiSwap,
          IconBalancer,
          IconPancake,
          IconDsspsm,
          IconSynapse,
          IconTokenlon,
        ]
    return iconArray.sort(() => Math.random() - 0.5)
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentRoutingImg((prev) => (prev + 1) % routingImages.length)
    }, 500)

    return () => clearInterval(interval)
  }, [])

  return (
    <StyledSearchContainer>
      <StyledRoutingContainer>
        <AnimatePresence>
          <motion.img
            key={currentRoutingImg}
            src={routingImages[currentRoutingImg]}
            initial={{ y: 18 }}
            animate={{ y: 0 }}
            exit={{ y: -18 }}
            transition={{ duration: 0.4 }}
            style={{
              width: '18px',
              height: '18px',
              position: 'absolute',
              bottom: 0,
            }}
          />
        </AnimatePresence>
      </StyledRoutingContainer>
      <span>{t('price_lookup')}</span>
    </StyledSearchContainer>
  )
}

export default DefaultLoading
